import AssetFormWrapper from "../../components/asset-forms/AssetFormWrapper";

/**
 * Precious Metals Asset Edit View
 * Now uses the unified AssetFormWrapper component
 */
const PreciousMetalsView = ({ assetId, startInEditMode }) => {
  return (
    <AssetFormWrapper
      mode="edit"
      subCategory="precious-metals"
      assetId={assetId}
      startInEditMode={startInEditMode}
    />
  );
};

export default PreciousMetalsView;
